import { Controller } from '@hotwired/stimulus'
import { turboRequest } from "../helpers/api"
export default class ShowcaseController extends Controller {
  connect() {
    this.image = []
  }

  checkSaleDate(e) {
    if ($(e.target).prop('checked')) {
      $('.end-date-input').removeClass('d-none')
    } else {
      $('.end-date-input').addClass('d-none')
      $('#showcase_sale_end_date').val('')
    }
  }

  checkAddress(e) {
    if ($(e.target).prop('checked')) {
      $('.address-form').addClass('d-none')
      $('[name=user_address_id]').removeClass('ignore_validation')
    }
  }

  checkAddressForm(e) {
    $('.address-form').removeClass('d-none')
    $('[name=user_address_id]').addClass('ignore_validation')
    $('.suggestion-address').each(function (index, element) {
      if ($(element).prop('checked')) {
        $(element).prop('checked', false)
      }
    })
  }

  selectShowcase(e) {
    if (e.target.closest('a')) {
      return;
    }
    if ($(e.currentTarget).hasClass('selected-cases')) {
      $(e.currentTarget).removeClass('selected-cases')
      let count = $('.selected-cases').length
      if (count > 0) {
        $('.selected-item-button').removeClass('d-none')
        $('.selected-item-count').text(`${count} ${count === 1 ? 'Item' : 'Items'} Selected`)
      } else {
        $('.selected-item-button').addClass('d-none')
      }
    } else {
      $(e.currentTarget).addClass('selected-cases')
      let count = $('.selected-cases').length
      if (count > 0) {
        $('.selected-item-button').removeClass('d-none')
        $('.selected-item-count').text(`${count} ${count === 1 ? 'Item' : 'Items'} Selected`)
      } else {
        $('.selected-item-button').addClass('d-none')
      }
    }
    this.image.push($(e.currentTarget).attr('data-number'))
  }

  async saveItem() {
    await turboRequest("/shopping_bags/save_showcase", {
      method: 'POST',
      params: {
        showcase_ids: this.image
      },
      onSuccess: () => {
        $(".selected-item-button").addClass("d-none")
      }
    })
  }

  async unsaveItem() {
    await turboRequest("/shopping_bags/unsave_showcase", {
      method: 'DELETE',
      params: {
        showcase_ids: this.image
      },
      onSuccess: () => {
        $(".selected-item-button").addClass("d-none")
      }
    })
  }

  buyItem(e) {
    fetch('/showcases/multiple_buy_now', {
      method: 'POST',
      headers: {
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.content || '',
        Accept: 'text/vnd.turbo-stream.html',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        showcase_ids: this.image
      })
    })
      .then((r) => r.text())
      .then((response) => {
        let truck_modal = document.getElementById('shareRecipeScrollModal')
        const modal = bootstrap.Modal.getInstance(truck_modal)
        modal.show()
        Turbo.renderStreamMessage(response)
      })
  }

  changeData(e) {
    let options = $(e.target).closest('.select-container').find('.option')
    const toggle = $(e.currentTarget)
      .closest('.dropdown')
      .find('[data-bs-toggle="dropdown"]')[0]

    options.each((index, e) => {
      if (e.dataset.showcaseOptionBound === 'true') return
      e.dataset.showcaseOptionBound = 'true'

      e.addEventListener('click', (event) => {
        event.stopPropagation()
        const container = e.closest('.select-container')
        const displayInput = container?.querySelector('input[type="text"]')
        const hiddenInput = container?.querySelector('input[type="hidden"]')

        if (displayInput) {
          displayInput.value = e.dataset.name.replaceAll(/Price\s*:\s*/gi, '').trim()
        }
        if (hiddenInput) {
          hiddenInput.value = e.dataset.value
          hiddenInput.name = e.dataset.id
        }
        options.removeClass('selected')
        e.classList.add('selected')

        const form = document.getElementById('sort_form')
        this.persistShowcaseFilters(form)
        form.requestSubmit()

        // Close dropdown after selecting an option
        const dropdown = bootstrap.Dropdown.getOrCreateInstance(toggle)
        dropdown?.hide()
      })
    })
  }

  persistShowcaseFilters(form) {
    if (!form) return

    const url = new URL(form.action, globalThis.location.href)
    const search = new URLSearchParams()

    for (const [name, value] of new FormData(form).entries()) {
      if (typeof value === 'string' && value.length > 0) {
        search.append(name, value)
      }
    }

    url.search = search.toString()
    globalThis.history.replaceState(globalThis.history.state, '', url)
  }

  changeTabContent(e) {
    let pane = $('.profile-tab-pane1')
    let sibling = $('.home-tab-pane1')
    if ($(e.currentTarget).attr('id') === 'profile-tab1') {
      sibling.removeClass('show active')
      pane.addClass('show active')
    } else {
      pane.removeClass('show active')
      sibling.addClass('show active')
    }
  }

  hideModel(e) {
    if ($('#shareRecipeScrollModal').is(':visible')) {
      const modal = bootstrap.Modal.getInstance($('#shareRecipeScrollModal'))
      modal.hide()
    }

    if ($('#shareRecipeModal').is(':visible')) {
      const modal = bootstrap.Modal.getInstance($('#shareRecipeModal'))
      modal.hide()
    }
  }
}
